import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-courier-profile p-2" }
const _hoisted_2 = { class: "grid grid-cols-12 justify-items-stretch gap-2" }
const _hoisted_3 = { class: "col-span-2 justify-self-center" }
const _hoisted_4 = { class: "col-span-10 pr-2" }
const _hoisted_5 = { class: "flex w-full justify-between items-center" }
const _hoisted_6 = { class: "text-black font-bold break-words" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "my-2" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-between text-xs p-2"
}
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "font-semibold  color-blue-grey" }, "Kendaraan", -1)
const _hoisted_12 = { class: "color-red font-semibold" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "font-semibold  color-blue-grey" }, "Paket Dibawa", -1)
const _hoisted_15 = { class: "color-red font-semibold" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ASSIGN ")
const _hoisted_17 = {
  key: 1,
  class: "flex gap-1 items-center"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "color-red font-semibold" }, "Detail", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-chevron-right color-red font-semibold",
  style: {"font-size":"0.9rem !important"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        ($setup.dataCourier.Picture)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: `${$setup.API_BASE}${$setup.dataCourier.Picture}`,
              class: "rounded-full object-cover w-12 h-12"
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_Avatar, {
              key: 1,
              label: $setup.dataCourier?.Nama?.charAt(0),
              shape: "circle",
              size: "large"
            }, null, 8, ["label"]))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString($setup.dataCourier.Nama), 1),
          _createVNode("i", {
            class: "pi pi-comment color-blue-grey w-5 h-5 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goWhatsApps && $setup.goWhatsApps(...args)))
          })
        ]),
        _createVNode("p", _hoisted_7, _toDisplayString($setup.dataCourier.Handphone) + " - " + _toDisplayString($setup.dataCourier.Status), 1)
      ])
    ]),
    _hoisted_8,
    ($props.showInfoManifest)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("p", _hoisted_12, "Motor (" + _toDisplayString($setup.dataCourier?.Kapasitas) + ")", 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("p", _hoisted_15, _toDisplayString($setup.dataCourier.PackageCount) + " Paket (" + _toDisplayString($setup.dataCourier.PackageWeight) + " KG)", 1)
          ]),
          ($setup.isAssign)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.assign($setup.dataCourier))),
                class: "font-semibold p-button-sm btn-primary rounded-lg"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}